<template>
  <div class="nav-bar-ctr">
    <div class="nav-content">
      <el-row>
        <el-col :span="2">
          <el-button type="text" @click="backToDashboard">
            <i class="el-icon-back back-icon"></i> Save & return
          </el-button>
        </el-col>
        <el-col :span="10">
          <el-tabs
            v-model="activeMainNav"
            @tab-click="handleTabClick"
            class="y-tabs y-sub-header-tabs"
          >
            <el-tab-pane
              v-for="item in tabs"
              :key="item.name"
              :label="item.title"
              :name="item.name"
            ></el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="12">
          <div class="y-sub-header-ctr newDesign" v-show="this.activeMainNav == 'configure'">
            <div class="y-sub-header-button-ctr">
              <span class="caption-text">{{ headerSubText }}</span>
              <el-button
                @click="previewSubbrand"
                :loading="previewLoding"
                class="y-button"
              >{{previewBtnText}}</el-button>
              <el-button type="primary" class="y-button">Apply changes privately</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sub-header-nav-bar',
  created() {},
  data() {
    return {
      tabs: [
        {
          title: 'Setup',
          name: 'setup'
        },
        {
          title: 'Configure',
          name: 'configure'
        }
      ],
      previewLoding: false,
      previewBtnText: 'Preview'
    }
  },
  computed: {
    activeMainNav: {
      set() {
        this.$store.state.appStore.activeMainNav
      },
      get() {
        return this.$store.state.appStore.activeMainNav
      }
    },
    headerSubText() {
      return this.$store.state.appStore.selectedSubbrandInfo.name
    }
  },
  methods: {
    backToDashboard() {
      this.$router.push('/dataloader')
    },
    handleTabClick(tab) {
      if (tab.name == 'setup') {
        this.$router.push('/subbrandSetup')
        this.$store.state.appStore.activeMainNav = 'setup'
      } else if (tab.name == 'configure') {
        this.$store.state.appStore.activeMainNav = 'configure'
        this.$router.push('/customization/CTDataloader')
      }
    },
    previewSubbrand() {
      // Add Loading Indicator
      this.previewLoding = true
      this.previewBtnText = 'loading preview'
      // Save brand data and Publish brand data
      //this.saveBrandData(true)
    }
  }
}
</script>

<style lang="scss">
.nav-bar-ctr {
  float: left;
  width: 100%;
  height: 62px;
  line-height: 62px;
  .nav-content {
    margin: 0px 16px;
  }
}
.back-icon {
  font-size: 18px;
  vertical-align: text-top !important;
}
.y-sub-header-ctr {
  height: 72px;
  min-height: 72px;
  line-height: 72px;
  padding-right: 24px;
}
.caption-text {
  margin-left: 16px;
  margin-right: 16px;
  font-size: 16px;
  color: #333333;
}
.y-sub-header-button-ctr {
  text-align: right;
}
</style>
